import { render, staticRenderFns } from "./AdminSideBar.vue?vue&type=template&id=57c2382c&scoped=true"
import script from "./AdminSideBar.vue?vue&type=script&lang=js"
export * from "./AdminSideBar.vue?vue&type=script&lang=js"
import style0 from "./AdminSideBar.vue?vue&type=style&index=0&id=57c2382c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2382c",
  null
  
)

export default component.exports